import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css";

function AdminLogin() {
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      id === process.env.REACT_APP_ADMIN_ID &&
      password === process.env.REACT_APP_ADMIN_PASSWORD
    ) {
      // 로그인 성공 시 세션스토리지에 인증 상태 저장
      sessionStorage.setItem("isAdminAuthenticated", "true");
      navigate("/ces/reservation/admin");
    } else {
      setError("아이디 또는 비밀번호가 올바르지 않습니다.");
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login-box">
        <h2 className="admin-login-title">관리자 로그인</h2>
        {error && <p className="admin-login-error">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="admin-login-input-group">
            <label htmlFor="admin-id">아이디</label>
            <input
              id="admin-id"
              type="text"
              value={id}
              onChange={(e) => setId(e.target.value)}
              placeholder="아이디를 입력하세요"
              required
            />
          </div>
          <div className="admin-login-input-group">
            <label htmlFor="admin-password">비밀번호</label>
            <input
              id="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="비밀번호를 입력하세요"
              required
            />
          </div>
          <button type="submit" className="admin-login-button">
            로그인
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
